module.exports = __webpack_public_path__ + "static/media/conwx_logo.f0df8846.svg";